import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import axios from 'axios';
import Login from '../../components/googleLogin/Login.js';

const localizer = momentLocalizer(moment);

const MyCalendar = () => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        axios.get('/api/google-calendar/events', { withCredentials: true })
            .then(response => {
                const formattedEvents = response.data.map(event => ({
                    title: event.title,
                    start: new Date(event.start),
                    end: new Date(event.end),
                }));
                setEvents(formattedEvents);
            })
            .catch(error => console.log(error));
    }, []);

    const handleSelect = ({ start, end }) => {
        const title = window.prompt('New Event name');
        if (title) {
            const newEvent = { title, start, end };
            axios.post('/api/google-calendar/events', newEvent, { withCredentials: true })
                .then(response => {
                    setEvents([...events, {
                        title: response.data.title,
                        start: new Date(response.data.start),
                        end: new Date(response.data.end),
                    }]);
                })
                .catch(error => console.log(error));
        }
    };

    return (
        <div>
            <h1>My Calendar</h1>
            <Login/>
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
                selectable
                onSelectSlot={handleSelect}
            />
        </div>
    );


};

export default MyCalendar;